import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { JarwisService } from 'src/app/Services/jarwis.service';
import * as shajs from 'sha.js';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-login-reset-password-popup',
  templateUrl: './login-reset-password-popup.component.html',
  styleUrls: ['./login-reset-password-popup.component.scss']
})
export class LoginResetPasswordPopupComponent implements OnInit {

  resetPasswordForm: FormGroup;
  error: any;

  constructor(
    private fb: FormBuilder,
    private jarwis: JarwisService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<LoginResetPasswordPopupComponent>
    ) {  }

  ngOnInit(): void { 
    this.createForm();
   }

  createForm() {
    this.resetPasswordForm = this.fb.group({
      email: [null, Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])],
      current_password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      new_password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      confirm_password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
    })
  }

  onSubmit(values) {
      let encryptedCurrentPassword = btoa(this.resetPasswordForm.controls.current_password.value);
      values['email'] = btoa(this.resetPasswordForm.controls.email.value);
      values['current_password'] = encryptedCurrentPassword;
      let encryptedNewPassword = shajs('sha512').update(this.resetPasswordForm.controls.new_password.value + values['email']).digest('hex');
      values['new_password'] = encryptedNewPassword;
      let encryptedConfirmPassword = shajs('sha512').update(this.resetPasswordForm.controls.confirm_password.value + values['email']).digest('hex');
      values['confirm_password'] = encryptedConfirmPassword;
      this.jarwis.resetExpiredPassword(values).subscribe(
        data => this.handleResponse(data),
        error => this.handleError(error)
      );
  }

  handleResponse(data) {
    if (data['type'] == 'Error') {
      this.toastr.error(data['message']);
      this.resetPasswordForm.reset();
    }else if(data['type'] == 'Success') {
      this.toastr.success(data['message']);
      this.dialogRef.close();
    }
  }

  handleError(error) {
    this.error = error.error.error;
    this.toastr.error(error.error.error);
  }

}
